export default __webpack_public_path__ + "media/Meat-Sausage-Ham.9b34a61d.png";